import React from 'react';

class MaxWidthDialog extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return <div>Hello</div>
    }
}
export default MaxWidthDialog;
